import { useEffect, useState } from "react"
import BIRP1 from "../../../../Assets/Images/BirForm/BIR_2307_P1.jpg"
import BIRP2 from "../../../../Assets/Images/BirForm/BIR_2307_P2.jpg"
import { createBir2037PurchasePayment } from "../../../../Helpers/apiCalls/Purchases/paySupplierApi"
import { createBir2037SalesPayment } from "../../../../Helpers/apiCalls/SalesModule/SalesInvoiceCashPayment"
import { createBir2037SalesInvoice } from "../../../../Helpers/apiCalls/SalesModule/SalesInvoiceApi"
import { createBir2037PurchaseInvoice } from "../../../../Helpers/apiCalls/Purchases/purchaseInvoiceApi"
import { createBir2037ExpensesInvoice } from "../../../../Helpers/apiCalls/Expenses/suppliesInvoiceApi"
import { createBir2037ExpensePayments } from "../../../../Helpers/apiCalls/Expenses/sePaymentsListApi"
import { formatDateDigitsOnly, numberFormat } from "../../../../Helpers/Utils/Common"

export default function BirForm(props) {
  const [details, setDetails] = useState([])

  async function fetchData() {
    var response
    if (props.type === "purchase-payments") {
      response = await createBir2037PurchasePayment(props.id, props.mode)
    } else if (props.type === "sales-payment") {
      response = await createBir2037SalesPayment(props.id, props.mode)
    } else if (props.type === "sales-invoice") {
      response = await createBir2037SalesInvoice(props.id)
    } else if (props.type === "purchase-invoice") {
      response = await createBir2037PurchaseInvoice(props.id)
    } else if (props.type === "supplies-receive") {
      response = await createBir2037ExpensesInvoice(props.id)
    } else if (props.type === "supplies-payment") {
      response = await createBir2037ExpensePayments(props.id, props.mode)
    }

    if (response && response.data) {
      setDetails(response.data.data)
    }
  }

  useEffect(() => {
    console.log(props.id)
    if (props.id !== undefined || props.id !== null || props.id !== "") {
      fetchData()
    }
  }, [props.id])

  return (
    <div className="page ms-5">
      <div id="printablediv" className="display-none">
        <div id="page-1" className="bir-form">
          <img src={BIRP1} alt="" className="" />
          <div className="bir-form-details-cont">
            <div>
              <div className="d-flex flex-row det-period-cont">
                <p className="det-period-from">
                  {formatDateDigitsOnly(details.period_from)}
                </p>
                <p className="det-period-to">
                  {formatDateDigitsOnly(details.period_to)}
                </p>
              </div>
              <div className="tin-cont">
                <p>{details.payee_tin}</p>
              </div>
              <div className="payee-cont">
                <p className="det-name">{details.payee}</p>
                <p className="det-address">
                  {details.payee_address}
                  <span className="det-zip">{details.payee_zipcode}</span>
                </p>
              </div>
              <div className="tin-payor-cont">
                <p>{details.payor_tin}</p>
              </div>
              <div className="payor-cont">
                <p className="det-name">{details.payor}</p>
                <p className="det-address">
                  {details.payor_address}
                  <span className="det-zip">{details.payor_zipcode}</span>
                </p>
              </div>
              <div className="mx-4 w-full payments-cont">
                {props.type === "sales-invoice" ||
                props.type === "purchase-invoice" ? (
                  <div className="sales-cont">
                    <p className="invoice-no">
                      {`Invoice ${
                        details.invoice_no !== null &&
                        details.invoice_no !== "null"
                          ? details.invoice_no
                          : details.dr_no !== null && details.dr_no !== "null"
                          ? details.dr_no
                          : details.id
                      }`}
                    </p>
                    <p
                      className={`${
                        details.quarter === 1
                          ? "vat-sales-cont-q1"
                          : details.quarter === 2
                          ? "vat-sales-cont-q2"
                          : "vat-sales-cont-q3"
                      }`}
                    >
                      {numberFormat(details.vatable_sales)}
                    </p>
                    <p className="total-vat-sales">
                      {numberFormat(details.vatable_sales)}
                    </p>
                    <p className="det-wht">
                      {numberFormat(details.withholding_tax)}
                    </p>
                  </div>
                ) : (
                  <div className="d-flex flex-column gap-1">
                    {details.invoices &&
                      details.invoices.map((item, index) => {
                        return (
                          <div key={index} className="sales-cont">
                            <div>
                              <p className="m-0 invoice-no">
                                Invoice No.{" "}
                                {item.invoice_no
                                  ? item.invoice_no
                                  : item.sales_invoice_id
                                  ? item.sales_invoice_id
                                  : item.id}
                              </p>
                            </div>
                            <p
                              className={`${
                                item.quarter === 1
                                  ? "vat-sales-cont-q1"
                                  : item.quarter === 2
                                  ? "vat-sales-cont-q2"
                                  : "vat-sales-cont-q3"
                              }`}
                            >
                              {item.vatable_sales}
                            </p>
                            <p className="total-vat-sales">
                              {item.vatable_sales}
                            </p>
                            <p className="det-wht">{item.withholding_tax}</p>
                          </div>
                        )
                      })}
                  </div>
                )}
              </div>
              <div className="det-bottom">
                <p className="det-payor">
                  {details.payor} (TIN: {details.payor_tin})
                </p>
                <p className="det-payee-bottom">
                  {details.payee} (TIN: {details.payee_tin})
                </p>
              </div>
              <div className="det-total-cont">
                <div className="w-full">
                  {details.total_quarter1 !== "0.00"
                    ? details.total_quarter1
                    : ""}
                </div>
                <div className="w-full">
                  {details.total_quarter2 !== "0.00"
                    ? details.total_quarter2
                    : ""}
                </div>
                <div className="w-full">
                  {details.total_quarter3 !== "0.00"
                    ? details.total_quarter3
                    : ""}
                </div>
                <div className="w-full">
                  {details.total_vatable_sales !== "0.00"
                    ? details.total_vatable_sales
                    : ""}
                </div>
                <div className="w-full">
                  {details.total_withholding_tax_amount !== "0.00"
                    ? details.total_withholding_tax_amount
                    : ""}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="page-2">
          <img src={BIRP2} alt="" className="" />
        </div>
      </div>
    </div>
  )
}
